import React from "react";
import { useClubTenders } from "../../hooks/clubtender/useClubTenders";
import ClubTendersHeader from "../../components/clubtender/ClubTendersHeader";
import ClubTendersMainContent from "../../components/clubtender/ClubTendersMainContent";
import TenderFilterModal from "../../components/club/TenderFilterModal";
import { effectiveSourceTab } from "../../utils/tenderSourceTabs";

const ClubTenders = () => {
  const {
    countries,
    navigate,
    canCreateTenders,
    activeMainTab,
    setActiveMainTab,
    activeSubTab,
    setActiveSubTab,
    selectedCountry,
    tenders,
    loading,
    error,
    showFilterModal,
    setShowFilterModal,
    transferWindow,
    transferWindowLoading,
    searchQuery,
    setSearchQuery,
    dropdownRef,
    searchInputRef,
    isMobile,
    filters,
    searchTerm,
    sortBy,
    activePositionFilter,
    pagination,
    formatDateRange,
    handleTransferWindowDropdownToggle,
    handleCountrySelect,
    handleFilterChange,
    clearAllFilters,
    hasActiveFilters,
    handleSortChange,
    handlePositionFilterChange,
    handleSearchChange,
    fetchTenders,
    handleSaveStatusChange,
    filteredCountries,
    isTransferWindowDropdownOpen,
    viewMode,
    changeViewMode,
    listSavingIds,
    handleListToggleSave,
    lifecycleTab,
    handleLifecycleChange,
    lifecycleCounts,
    refreshTenders,
  } = useClubTenders();

  return (
    <div className="min-h-screen bg-gray-50">
      <ClubTendersHeader
        isMobile={isMobile}
        transferWindowLoading={transferWindowLoading}
        transferWindow={transferWindow}
        formatDateRange={formatDateRange}
        dropdownRef={dropdownRef}
        searchInputRef={searchInputRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleTransferWindowDropdownToggle={handleTransferWindowDropdownToggle}
        countries={countries}
        selectedCountry={selectedCountry}
        isTransferWindowDropdownOpen={isTransferWindowDropdownOpen}
        filteredCountries={filteredCountries}
        handleCountrySelect={handleCountrySelect}
        canCreateTenders={canCreateTenders}
        navigate={navigate}
        activeMainTab={activeMainTab}
        setActiveMainTab={setActiveMainTab}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
        setShowFilterModal={setShowFilterModal}
        hasActiveFilters={hasActiveFilters}
        clearAllFilters={clearAllFilters}
        sortBy={sortBy}
        handleSortChange={handleSortChange}
        filters={filters}
        handleFilterChange={handleFilterChange}
      />

      {/* Main Content */}
      <ClubTendersMainContent
        isMobile={isMobile}
        activeMainTab={activeMainTab}
        setActiveMainTab={setActiveMainTab}
        setShowFilterModal={setShowFilterModal}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
        activeSubTab={activeSubTab}
        setActiveSubTab={setActiveSubTab}
        /* The Pro / Youth pair went to the desktop header only; the phone
           renders its own copy of that dropdown inside MobileTenderTabs. */
        sortBy={sortBy}
        handleSortChange={handleSortChange}
        activePositionFilter={activePositionFilter}
        handlePositionFilterChange={handlePositionFilterChange}
        loading={loading}
        error={error}
        tenders={tenders}
        pagination={pagination}
        fetchTenders={fetchTenders}
        handleSaveStatusChange={handleSaveStatusChange}
        viewMode={viewMode}
        changeViewMode={changeViewMode}
        listSavingIds={listSavingIds}
        handleListToggleSave={handleListToggleSave}
        /* Request drafts: the lifecycle segment and everything it needs. The
           page's own transfer-window payload travels down so the schedule
           picker's hint reads the same window the header shows. */
        lifecycleTab={lifecycleTab}
        onLifecycleChange={handleLifecycleChange}
        lifecycleCounts={lifecycleCounts}
        transferWindow={transferWindow}
        onDraftChanged={refreshTenders}
        canCreateTenders={canCreateTenders}
        navigate={navigate}
      />

      {/* Filter Modal */}
      <TenderFilterModal
        isOpen={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        onApply={handleFilterChange}
        initialFilters={filters}
        selectedType={activePositionFilter}
        /* DECISION 050 follow-up: the option counts describe the tab that is
           actually open — My Requests counts this club's own rows in every
           status, Saved counts the bookmarks, All Requests the active
           marketplace. Same for the TP-Lite sub-tab. */
        activeTab={activeMainTab}
        /* effectiveSourceTab, not the raw state: the TP / TP Lite switch is
           only offered on All Listed Requests, so on the other tabs the option
           counts must describe the default source rather than a choice the
           user made somewhere the switch was visible. */
        isLite={
          effectiveSourceTab(activeMainTab, activeSubTab) === "tp-lite-tenders"
        }
      />
    </div>
  );
};

export default ClubTenders;
